import { Box } from '@chakra-ui/react';
import { Button, Icon } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import PreviousChatsList from 'components/widgets/ScoutAgent/Sidebar/PreviousChatsList';
import { ScoutChatItem } from 'services/API/AIInteractionAPI';

const sidebarStyle = {
  width: '280px',
  minWidth: '280px',
  height: '100%',
  backgroundColor: 'brand.grey-lighter',
  padding: 'padding_16',
  borderRight: '1px solid',
  borderColor: 'brand.tan-200',
};

const newChatButtonStyle = {
  marginBottom: 'padding_16',
};

type SidebarProps = {
  chats: ScoutChatItem[];
  selectedChatId?: string | null;
  onNewChat?: () => void;
  onSelectChat?: (id: string, name: string) => void;
};

const Sidebar = ({ chats, selectedChatId, onNewChat, onSelectChat }: SidebarProps) => {
  return (
    <Box as="aside" sx={sidebarStyle}>
      <FlexColumn sx={{ height: '100%', gap: 'padding_32' }}>
        <Button
          variant="primary"
          onClick={onNewChat}
          startAdornment={<Icon name={Icon.Name.AddToList} />}
          sx={newChatButtonStyle}
        >
          New chat
        </Button>
        <PreviousChatsList
          chats={chats}
          selectedChatId={selectedChatId}
          onSelectChat={onSelectChat}
        />
      </FlexColumn>
    </Box>
  );
};

export default Sidebar;
